import { AgGridReact } from "ag-grid-react";
import {
  defaultColDef,
  getRowId,
  getUserRowStyle,
  userColumns,
} from "../../utils/gridHelper";
import { useCallback, useEffect, useMemo, useState } from "react";
import GridToolBar from "../GridToolBar";
import { useStore } from "../../hooks/store";
import { getUser, getUserCredit } from "../../utils/API/userMethods";
import { useNavigate } from "react-router";
import NewUserForm from "../Form/NewUserForm";
import { getSchool } from "../../utils/API/schoolMethods.js";
export default function UserGrid() {
  const store = useStore();
  const [gridData, setGridData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [quickFilterText, setQuickFilterText] = useState("");
  const [userData, setBiletData] = useState(undefined);
  const nav = useNavigate();

  const fetchUserData = () => {
    getUser().then(({ data }) => {
      setGridData(data);
    });
  };

  const handleAddOpener = () => {
    window.history.replaceState({}, "");
    getSchool().then(({ data, status }) => {
      store.setForm(<NewUserForm />, fetchUserData, { schoolList: data });
    });
  };

  const handleRedactOpener = () => {
    const { id } = userData;
    getUserCredit(id).then((result) => {
      getSchool().then((schoolResult) => {
        nav(id, {
          state: {
            ...userData,
            ...result.data[0],
            schoolList: schoolResult.data,
          },
        });
      });
    });
  };

  const onGridReady = useCallback((e) => {
    // сохраняем АПИ
    setGridApi(e.api);
    fetchUserData();
  }, []);

  //Отслеживаем изменение текста для фильтра, устанавливаем соответстствующий фильтр в грид
  useEffect(() => {
    gridApi?.setGridOption("quickFilterText", quickFilterText);
  }, [quickFilterText, gridApi]);

  //выбор конрентной строки
  const rowSelection = useMemo(() => {
    return {
      mode: "singleRow",
      checkboxes: true,
      enableClickSelection: true,
    };
  }, []);

  const rowClickHandler = (e) => {
    e.data && setBiletData(e.data);
  };

  return (
    <div style={{ maxWidth: "100%", height: "100%" }}>
      <GridToolBar
        filter={true}
        onAdd={handleAddOpener}
        onRefresh={fetchUserData}
        // onDelete={handleDelete}
        onUpdate={handleRedactOpener}
        filterValue={quickFilterText}
        filterOnChange={setQuickFilterText}
        dataToAction={userData}
      />
      <AgGridReact
        onGridReady={onGridReady}
        onRowClicked={rowClickHandler}
        gerRowId={getRowId}
        rowData={gridData}
        defaultColDef={defaultColDef}
        tooltipShowDelay={500}
        rowSelection={rowSelection}
        columnDefs={[...userColumns]}
        getRowStyle={getUserRowStyle}
      />
    </div>
  );
}
